import { Box, Divider, Text } from "@chakra-ui/react";
import { KYD_AUDIENCE_DIALOG_STYLES } from "./kydAudienceDialogStyles";

const styles = KYD_AUDIENCE_DIALOG_STYLES;

export default function KydAudienceOrDivider() {
  return (
    <Box position="relative" w="full" py={3}>
      <Divider borderColor="gray.300" />
      <Box
        position="absolute"
        left="50%"
        top="50%"
        transform="translate(-50%, -50%)"
        bg={styles.shellBg}
        px={3}
      >
        <Text
          fontFamily={styles.fontFamily}
          fontSize={styles.sectionLabelFontSize}
          fontWeight={styles.sectionLabelFontWeight}
          color={styles.orLabelColor}
          lineHeight="24px"
        >
          OR
        </Text>
      </Box>
    </Box>
  );
}
